
        import 'FormattedPrice.449e2a6.css-module'
        export default {"FormattedPrice":"FormattedPrice_FormattedPrice_449e2a6"}
    